import { ScheduleData } from '../../hook/ScheduleData.js';
import './ExamSchedule.css';

function ExamSchedule() 
{
  const { data: examData, loading, error } = ScheduleData('/ExamSchedule', null, null);

  if (loading) return <div className='loading'>Загрузка расписания сессии...</div>;
  if (error)   return <div className='error'>Ошибка: {error}</div>;
  if (!examData || examData.length === 0) return <div className='error'>Расписание сессии пока не опубликовано</div>;

  return (
    <div className='exam-schedule-container'>
      <div className='group-header'>
        <h1>Расписание экзаменационной сессии</h1>
      </div>

      {examData.map((day) => (
        <div key={day.date} className='exam-day'>
          <div className='exam-day-header'>
            <h2>{day.day_week.toUpperCase()}</h2>
            <h3>{day.date}</h3>
          </div>

          <div className='exam-list'>
            {day.exams.map((exam, idx) => (
              <div key={idx} className='exam-card'>
                <div className='exam-time'>{exam.time_start}</div>

                <div className='exam-details'>
                  <h5>{exam.subject}</h5>
                  <p className='exam-meta-line'>
                    Группа: <b>{exam.group_name}</b> ({exam.course} курс)
                  </p>
                  <p className='exam-meta-line'>
                    Преподаватели: {Array.isArray(exam.teachers) ? exam.teachers.join(', ') : exam.teachers}
                  </p>
                  <div className='pair-meta'>
                    <span className='pair-type'>{exam.event_type}</span>
                    <span className='classroom'>Аудитория: {exam.class_room}</span>
                  </div>
                  {exam.speciality && (
                    <p className='exam-speciality'>{exam.speciality}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ExamSchedule;